import React, { useState } from 'react';
import { createModal } from 'react-modal-promise';
import { Modal, Button, Checkbox, theme } from 'Ui';
import styled from 'styled-components/macro';
import Cookies from 'js-cookie';
import UiStore from 'Store/UiStore';
import { registerUserRgpdBehaviou } from 'Libs/trackingInternal';
import { useApolloClient } from '@apollo/client';
import RgpBannerModal from './RgdpBannerModal';

import { DeviceEnum } from '__generated__/graphql-global-types';
import { isMobile } from 'react-device-detect';
import { setCookie } from 'Utils/cookie';
import { getPrivacyChoice } from 'Libs/GA4/common';
import { Trans, useTranslation } from 'react-i18next';

type ModalProps = {
  open: boolean;
  close: (shouldGoToCheckout: boolean) => void;
  disabledOutsideClickHandler?: boolean;
  external?: boolean;
};

const RgpdModalBody = styled.div`
  flex: 1;
  display: flex;
  font-family: var(--font-primary);
  flex-direction: column;
  font-size: 1.4rem;
`;

const RgpdModalDesc = styled.p`
  margin-bottom: 30px;
  line-height: 1.9rem;
`;

const RgpdBodyTitle = styled.div`
  margin-bottom: 10px;
  font-size: 16px;
  font-family: var(--font-primary);
`;

const RgpdModalLabel = styled.div`
  p {
    padding: 0.2rem 0 0 4rem;
    line-height: 1.9rem;
    a:hover {
      color: ${theme.v2.brand.violet};
    }
  }

  .marginCheckbox {
    margin-top: 2rem;
  }
  span {
    text-transform: uppercase;
    align-self: center;
  }
`;

const RgpdModal = ({
  open,
  close,
  disabledOutsideClickHandler,
  external,
}: ModalProps) => {
  const cookiePerformance = Cookies.get('_performance') ? true : false;
  const cookieMarketing = Cookies.get('_marketing') ? true : false;
  const setDisclaimer = UiStore.useStoreActions(
    (action) => action.setDisclaimer
  );

  const consultedSales = UiStore.useStoreActions(
    (action) => action.setConsultedSales
  );

  const setCookieMarketingStore = UiStore.useStoreActions(
    (action) => action.setCookieMarketing
  );
  const setGtmConsentMode = UiStore.useStoreActions(
    (action) => action.setGtmConsentMode
  );

  const setAcceptedAndRefusedCookieReload = UiStore.useStoreActions(
    (action) => action.setAcceptedAndRefusedCookieReload
  );

  const disclaimer = () => {
    if (!!Cookies.get('majeur') === false) {
      setDisclaimer(true);
    }
  };
  const [performance, setPerformance] = useState(cookiePerformance);
  const [marketing, setMarketing] = useState(cookieMarketing);
  const configCookie = { domain: '.bazarchic.com', expires: 180, secure: true };
  const apolloClient = useApolloClient();
  const deviceType = isMobile ? DeviceEnum.MOBILE : DeviceEnum.DESKTOP;

  const registerRGPD = (sdkPerf: boolean, sdkMarket: boolean) => {
    const btnPersonnalize = true;
    const btnAccept = false;
    const btnDeny = false;
    const linkPvp = !!localStorage.getItem('linkPvp');
    registerUserRgpdBehaviou(
      apolloClient,
      sdkPerf,
      sdkMarket,
      btnPersonnalize,
      btnAccept,
      btnDeny,
      linkPvp,
      deviceType
    );
  };

  const RGPDValidate = () => {
    disclaimer();
    if (performance) {
      const objectCookie = {
        path: '/',
        value: '1',
        name: '_performance',
        domain: '.bazarchic.com',
        expires: 180,
        secure: true,
      };
      setCookie(objectCookie);
      // Cookies.set('_performance', '1', configCookie);
    } else {
      Cookies.remove('_performance', configCookie);
    }
    if (marketing) {
      const objectCookie = {
        path: '/',
        value: '1',
        name: '_marketing',
        domain: '.bazarchic.com',
        expires: 180,
        secure: true,
      };
      setCookie(objectCookie);
      // Cookies.set('_marketing', '1', configCookie);
    } else {
      Cookies.remove('_marketing', configCookie);
      Cookies.remove('sPagesHistoryV2', configCookie);
      Cookies.remove('sProductsHistoryV2', configCookie);
      Cookies.remove('birthdayReminder', configCookie);
      Cookies.remove('site', configCookie);
      consultedSales([]);
    }
    Cookies.set('RgpdBanner', '1', configCookie);
    registerRGPD(performance, marketing);
    setCookieMarketingStore(marketing);
    setAcceptedAndRefusedCookieReload(true);
    if (!!localStorage.getItem('linkPvp')) {
      localStorage.removeItem('linkPvp');
    }
    if (external) {
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
  };

  const onClose = () => {
    if (!Cookies.get('RgpdBanner')) {
      {
        if (!disabledOutsideClickHandler) {
          RgpBannerModal({});
        }
      }
    }
    close(false);
  };

  const { t } = useTranslation('rgpd', { useSuspense: false });

  const rgpdTranslate = {
    modal: {
      titleModal: t('modal.titleModal'),
      validate: t('modal.validate'),
      navigationCookieTitle: t('modal.navigationCookieTitle'),
      navigationCookieDesc: t('modal.navigationCookieDesc'),
      navigationCookieDesc2: t('modal.navigationCookieDesc2'),
      parametersCookieTitle: t('modal.parametersCookieTitle'),
      performanceCookieTitle: t('modal.performanceCookieTitle'),
      performanceCookieDesc: t('modal.performanceCookieDesc'),
      marketingCookieTitle: t('modal.marketingCookieTitle'),
      marketingCookieDesc: t('modal.marketingCookieDesc'),
      marketingCookieDesc2: t('modal.marketingCookieDesc2'),
    },
  };

  return (
    <Modal
      disabledOutsideClickHandler={disabledOutsideClickHandler}
      isOpen={open}
      onClose={() => onClose()}
      size="large"
      title={rgpdTranslate.modal.titleModal}
      actions={
        <>
          <Button
            kind="primary"
            onClick={() => {
              RGPDValidate();
              setGtmConsentMode('update');
              sessionStorage.setItem('consent', 'oui');
              setTimeout(getPrivacyChoice, 3000);
              close(true);
            }}
          >
            {rgpdTranslate.modal.validate}
          </Button>
        </>
      }
    >
      <RgpdModalBody>
        <RgpdBodyTitle>
          {rgpdTranslate.modal.navigationCookieTitle}
        </RgpdBodyTitle>
        <RgpdModalDesc>
          {rgpdTranslate.modal.navigationCookieDesc}
          <br />
          {rgpdTranslate.modal.navigationCookieDesc2}
        </RgpdModalDesc>

        <RgpdBodyTitle>
          {rgpdTranslate.modal.parametersCookieTitle}
        </RgpdBodyTitle>
        <div>
          <RgpdModalLabel onClick={() => setPerformance(!performance)}>
            <Checkbox
              size={2}
              sizeCheck={1}
              width={1.6}
              height={1.6}
              checked={performance}
              onChange={() => {}}
              label={rgpdTranslate.modal.performanceCookieTitle}
            />
            <p>{rgpdTranslate.modal.performanceCookieDesc}</p>
          </RgpdModalLabel>

          <RgpdModalLabel onClick={() => setMarketing(!marketing)}>
            <Checkbox
              className="marginCheckbox"
              size={2}
              sizeCheck={3}
              width={1.6}
              height={1.6}
              checked={marketing}
              onChange={() => {
                setMarketing(!marketing);
              }}
              label={rgpdTranslate.modal.marketingCookieTitle}
            />
            <p>{rgpdTranslate.modal.marketingCookieDesc}</p>
            <p>
              {rgpdTranslate.modal.marketingCookieDesc2}{' '}
              <a target="_blank" href="https://business.safety.google/privacy/">
                Google
              </a>
              ,{' '}
              <a
                target="_blank"
                href="https://www.facebook.com/privacy/policy/"
              >
                Meta
              </a>
              ,{' '}
              <a
                href="https://batch.com/fr/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Batch
              </a>
              ,{' '}
              <a
                href="https://affilae.com/fr/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Affilae
              </a>
              ,{' '}
              <a
                href="https://rtb.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                RTB House
              </a>
              .
            </p>
          </RgpdModalLabel>
        </div>
      </RgpdModalBody>
    </Modal>
  );
};

export default createModal(RgpdModal);
